import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Πολιτική Απορρήτου UniTech</h1>
      Το UniTech χρησιμοποιεί τα στοιχεία σύνδεσης του ιδρυματικού λογαριασμού σας έτσι ώστε να σας παρέχει την ανάλυση της βαθμολογίας σας. Τα στοιχεία αποθηκεύονται ΜΟΝΟ στην συσκευή σας εάν εσείς το επιλέξετε. Δεν συλλέγονται και δεν κοινοποιούνται σε άλλους πέρα από το σύστημα του Εθνικού Μετσόβιου Πολυτεχνείου όταν κάνετε σύνδεση.</div>
  );
}

export default App;
